var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShow)?_c('div',{staticClass:"recaptcha-branding",domProps:{"innerHTML":_vm._s(_vm.$t('brandText'))}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }